import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import { VigenciasSolicitudes } from '../_models/vigencias';

@Injectable({
    providedIn: 'root'
})
export class ValidityRequestsService {

  serviceURL = AppSettings.rutServiciosAPL + '/api/vigenciasSolicitudes';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  getAll() {
     return this.authHttp.get( this.serviceURL ).pipe( map( res => res as VigenciasSolicitudes[] ) );
  }

  getAllEnable() {
     return this.authHttp.get( this.serviceURL + '/enabled' ).pipe( map( res => res as VigenciasSolicitudes[] ) );
  }

  getById( id: string ) {
     return this.authHttp.get( this.serviceURL + '/' + id  ).pipe( map( res => res as VigenciasSolicitudes ) );
  }

  add( c: VigenciasSolicitudes ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.post( this.serviceURL, c ).pipe( map( res => res as VigenciasSolicitudes ) );
  }

  update( c: VigenciasSolicitudes ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.put( this.serviceURL , c ).pipe( map( res => res as VigenciasSolicitudes ) );
  }
}
